import type { ProviderConfig } from 'config-types';

const PROVIDER_DATA: ProviderConfig = {
  assessment: {
    emCodeOptions: [
      { display: '99202 New Patient - E/M Level 2', code: '99202' },
      { display: '99203 New Patient - E/M Level 3', code: '99203' },
      { display: '99204 New Patient - E/M Level 4', code: '99204' },
      { display: '99205 New Patient - E/M Level 5', code: '99205' },
      { display: '99212 Established Patient - E/M Level 2', code: '99212' },
      { display: '99213 Established Patient - E/M Level 3', code: '99213' },
      { display: '99214 Established Patient - E/M Level 4', code: '99214' },
      { display: '99215 Established Patient - E/M Level 5', code: '99215' },
      { display: '99499 - Unlisted E&M Service', code: '99499' },
      { display: '99080 Preparation of special reports beyond what is found in the medical record', code: '99080' },
      {
        display:
          '99211 - Office or other outpatient visit for the evaluation and management of established patient that may not require presence of healthcare professional',
        code: '99211',
      },
      {
        display: '99455 - Work-related or medical disability evaluation by the treating physician',
        code: '99455',
      },
    ],
    visionAutoCptCodes: ['99173'],
  },
};

export const PROVIDER_CONFIG = Object.freeze(PROVIDER_DATA);
